import { ProfileType } from 'data/interfaces/IRegistration';
import { FC } from 'react';
import styles from './index.module.scss';

interface MenuItem {
  key: string;
  element: React.ReactNode;
}

interface Props {
  menuItems: MenuItem[];
  profileType: ProfileType;
}

const roleItems = {
  employeeKeys: new Set(['profile', 'settings', 'character', 'logout']),
  hirerKeys: new Set(['profile', 'settings', 'logout']),
};

const DropdownPlatform: FC<Props> = ({ menuItems, profileType }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.menuItems}>
        {menuItems
          .filter((item) => roleItems[`${profileType}Keys`].has(item.key))
          .map((item) => (
            <div key={item.key}>{item.element}</div>
          ))}
      </div>
    </div>
  );
};

export default DropdownPlatform;
